import { Input } from "@/components/ui/input";

export const sdExtra = (option) => {
  const m = /\+\s*(\d)\s*additional/i.exec(option?.name || "");
  return m && !option?.added_by ? Number(m[1]) : 0;
};

export const SdGuestsInput = ({ option, value = [], onChange, testId = "sd-guests" }) => {
  const n = sdExtra(option);
  if (!n) { return null; }
  const set = (i, v) => { const next = [...value]; next[i] = v.toUpperCase(); onChange(next.slice(0, n)); };
  return (
    <div className="mt-3 rounded-md border border-amber-300 bg-amber-50 p-3" data-testid={testId}>
      <div className="text-sm font-semibold">Ticket number{n > 1 ? "s" : ""} of the additional member{n > 1 ? "s" : ""}</div>
      <p className="text-xs text-gray-600 mb-2">They must already be registered for this event. Each person can only be added by one participant.</p>
      <div className={`grid gap-2 ${n > 1 ? "sm:grid-cols-2" : ""}`}>
        {Array.from({ length: n }, (_, i) => (
          <Input key={i} value={value[i] || ""} onChange={(e) => set(i, e.target.value)} placeholder={`Ticket no. of person ${i + 1}`} maxLength={30}
            className="h-10 font-mono uppercase placeholder:normal-case bg-white" data-testid={`${testId}-input-${i}`} />
        ))}
      </div>
    </div>
  );
};
